import { useEffect, useRef } from "react";
import Header from "../../../components/header";
import RabbitFestivalInterview from "./components/interview";
import RabbitFestivalMain from "./components/main";
import { useRabbitFestivalContext } from "./hooks/festival-context";
import { RabbitFestivalPage } from "./hooks/use-festival-tab";
import { RabbitFestivalWrapper } from "./style";
import RabbitFestivalCompetitions from "./components/competition-list";
import { useHistory } from "react-router-dom";
import RabbitFestivalCompetition from "./components/competition";
import RabbitFestivalEvent from "./components/event";

const RabbitFestival = () => {
  const {
    showHeader,
    isFestivalPage,
    festivalPage,
    setShowHeader,
    setFestivalPage,
  } = useRabbitFestivalContext();
  const mainRef = useRef<HTMLDivElement | null>(null);
  const history = useHistory();

  // 페이지 이동 시 스크롤 최상단
  useEffect(() => {
    const el = mainRef.current;
    if (el) {
      el.scrollTo({ top: 0, behavior: "auto" });
    }
    setShowHeader(true);
  }, [festivalPage]);

  return (
    <RabbitFestivalWrapper ref={mainRef}>
      {(isFestivalPage(RabbitFestivalPage.MAIN) ||
        isFestivalPage(RabbitFestivalPage.COMPETITIONS)) && (
        <Header
          title="RABBIT FESTIVAL"
          show={showHeader}
          back={() =>
            isFestivalPage(RabbitFestivalPage.COMPETITIONS)
              ? setFestivalPage(RabbitFestivalPage.MAIN)
              : history.push("/home")
          }
        />
      )}
      {isFestivalPage(RabbitFestivalPage.MAIN) && <RabbitFestivalMain />}
      {isFestivalPage(RabbitFestivalPage.INTERVIEW) && (
        <RabbitFestivalInterview />
      )}
      {isFestivalPage(RabbitFestivalPage.COMPETITIONS) && (
        <RabbitFestivalCompetitions />
      )}
      {isFestivalPage(RabbitFestivalPage.COMPETITION) && (
        <RabbitFestivalCompetition />
      )}
      {isFestivalPage(RabbitFestivalPage.EVENT) && <RabbitFestivalEvent />}
    </RabbitFestivalWrapper>
  );
};

export default RabbitFestival;
